export function getDevProxyList() {
  let serverName = 'siteboot';
  /*
  * 代理切换测试和集成是需要切换本地host且用对应的域名访问
  * 代理测试时如需下载文件则在env.development打开测试的VITE_GLOB_DOMAIN_URL即可
  * 开发访问地址示例：http://ecn.ecloud.echartnow.cn:3100
  * 开发时只需在浏览器切换对应人名即可，此文件只在增加后端IP时修改
  * */

  serverName='dev1';
  // serverName='ceshi'; //测试
  // serverName='siteboot'; //集成

  const serverList = [
    {
      name: 'dev1:43',
      url: 'http://192.168.1.43:9999',
      configPath: 'dev1'
    }, {
      name: 'dev2:95',
      url: 'http://192.168.1.95:9999',
      configPath: 'dev2'
    }, {
      name: '冀未龙:139',
      url: 'http://192.168.1.139:9999',
      configPath: 'weilong1'
    },  {
      name: '冀未龙:168',
      url: 'http://192.168.1.168:9999',
      configPath: 'weilong2'
    }, {
      name: '牛帅:163',
      url: 'http://192.168.1.163:9999',
      configPath: 'niushuai'
    },  {
      name: '庞林豪:13',
      url: 'http://192.168.1.13:9999',
      configPath: 'panglinhao'
    },{
      name: '邓向阳:162',
      url: 'http://192.168.1.162:9999',
      configPath: 'dengxiangyang'
    }, {
      name: '李文钊:55',
      url: 'http://192.168.1.55:9999',
      configPath: 'liwenzhao'
    }, {
      name: '郭甲奇:45',
      url: 'http://192.168.1.45:9999',
      configPath: 'guojiaqi'
    },  {
      name: '景龙龙:250',
      url: 'http://192.168.1.250:9999',
      configPath: 'jinglonglong'
    }, {
      name: '秦辉朝:65',
      url: 'http://192.168.1.65:9999',
      configPath: 'qinhuichao'
    }, {
      name: '王克:35',
      url: 'http://192.168.1.35:9999',
      configPath: 'wangke'
    }, {
      name: '测试',
      url: 'https://testmdbesppgw.echartnow.com',
      configPath: 'ceshi'
    }, {
      name: '集成',
      url: 'https://devmdbesppgw.echartnow.com',
      configPath: 'siteboot'
    },
  ];

  const devProxyList: [string, string][] = serverList.map((item): [string, string] => {
    return [`/${item.configPath}/jeecgboot`, item.url];
  });
  const activeServer = serverName ? serverList.find((item) => item.configPath === serverName) : serverList.at(-1);
  if (serverName) {
    devProxyList.push(["/jeecgboot/storage/upload", `${activeServer?.url ?? ''}/storage/upload`]);
    devProxyList.push(["/jeecgboot", activeServer?.url ?? '']);
  } else {
    devProxyList.push(["/jeecgboot", activeServer?.url ?? '']);
  }
  return {devProxyList, serverName, serverList};
}
